import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

import {dev_featurePoints_template} from "../components/templates/dev_featurePoints_template";

declare var ko: any;
declare var page: any;

export class dev_featurePoints extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected featurePointsTemplate: dev_featurePoints_template;

    protected getModuleName(){

        return "dev_featurePoints";
    }

    buildContent() : Array<Element>{

        // create the users list
        this.featurePointsTemplate = new dev_featurePoints_template("list", this.viewModel, this);

        return [this.featurePointsTemplate.build()];
    }

    public fillPage() : void{

        this.getPoints();
    }

    public getPoints(){

        // LOADING : starts
        // todo

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let usrReq_url: string = '/api/featurePoints/get_pointsByQuarter/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON({quarter: "2020-1"})] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        let localCheck = this.XHRHdl.requestId;
        let _myThis = this;
        setTimeout(function(){

            if( localCheck == _myThis.XHRHdl.requestId ){
                _myThis.XHRHdl.onReadyStateFunction = _myThis.onGetPointsRequestReturn;
                _myThis.XHRHdl.execute();
            }
        }, 400);
    }

    public onGetPointsRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                console.log(responseParsed);
                obj.featurePointsTemplate.setPoints(responseParsed.points);
                obj.featurePointsTemplate.drawCharts();
            });
        };
    }

    public insertData(){

        // LOADING : starts
        // todo

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let usrReq_url: string = '/api/featurePoints/set_pointsByQuarter/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.featurePointsTemplate.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        let localCheck = this.XHRHdl.requestId;
        let _myThis = this;
        setTimeout(function(){

            if( localCheck == _myThis.XHRHdl.requestId ){
                _myThis.XHRHdl.onReadyStateFunction = _myThis.onSetPointsRequestReturn;
                _myThis.XHRHdl.execute();
            }
        }, 400);

    }

    public onSetPointsRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                obj.getPoints();
            });
        };
    }
}



// WEBPACK FOOTER //
// ./js/modules/dev_featurePoints.ts